import React from "react";

export const ThunderIcon = (): JSX.Element => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                d="M6.95456 2.88879V4.13721C6.95456 4.57295 6.95456 4.79082 7.09005 4.92591C7.22553 5.061 7.4434 5.06036 7.87914 5.05907L8.28799 5.05787C9.11164 5.05545 9.52346 5.05424 9.65038 5.31311C9.7773 5.57197 9.52414 5.8968 9.01781 6.54644L6.47635 9.8073C5.79186 10.6855 5.44962 11.1247 5.13849 11.0177C4.82736 10.9108 4.82736 10.3541 4.82736 9.2406V8.17927C4.82736 7.7447 4.82736 7.52741 4.69236 7.3924C4.55735 7.2574 4.34007 7.2574 3.90549 7.2574H3.6454C2.87283 7.2574 2.48655 7.2574 2.35713 7.01034C2.22772 6.76329 2.44767 6.44573 2.88755 5.81063L5.27485 2.36389C5.96339 1.36979 6.30766 0.872733 6.63111 0.97381C6.95456 1.07489 6.95456 1.67952 6.95456 2.88879Z"
                fill="#00A16C"
            />
        </svg>
    );
};
